import React from "react";
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography";

const ShowcaseCards = () => {
  return (
    <div 
      className="flex flex-col md:max-w-[704px] lg:max-w-[858px] items-start justify-between gap-[30px]"
    >
      <CMSRender
        contentType="HomePageCard"
        renderItem = {(card, id) => (
          <div
            key={id}
            className="flex flex-col items-start justify-center bg-gradient_showcase_card gap-[30px] p-[32px] md:p-[60px] lg:p-[40px] xl:p-[60px] rounded-[50px]"
          >
            <div className="flex w-[60px] h-[60px]">
              <img
                src={card.icon}
                alt={card.title}
                className=" w-[50px] h-[50px]"
              />
            </div>

            <Typography variant="h2" className="text-text">
              {card.title}
            </Typography>

            <Typography variant="body1">
              {card.text}
            </Typography>
          </div>
        )}
      />
    </div> 
  );
};

export default ShowcaseCards;
